import { ProductCategory, PetType } from '../types/types';

export const PRODUCT_CATEGORIES: { value: ProductCategory; label: string; icon: string }[] = [
    { value: 'Food', label: 'Food', icon: '🍖' },
    { value: 'Treats', label: 'Treats', icon: '🦴' },
    { value: 'Health', label: 'Health & Wellness', icon: '💊' },
    { value: 'Accessories', label: 'Accessories', icon: '🎀' },
    { value: 'Seasonal', label: 'Seasonal', icon: '🎃' },
    { value: 'Lifestyle', label: 'Lifestyle', icon: '🛋️' },
];

export const PET_TYPES: { value: PetType; label: string }[] = [
    { value: 'Dog', label: 'Dogs' },
    { value: 'Cat', label: 'Cats' },
    { value: 'Bird', label: 'Birds' },
    { value: 'Small Animal', label: 'Small Animals' },
    { value: 'All', label: 'All Pets' },
];

export const ROUTES = {
    HOME: '/',
    PRODUCTS: '/products',
    PRODUCT_DETAILS: '/product/:id',
    ADD_PRODUCT: '/add-product',
    REVIEWS: '/reviews',
};
